import _ from 'underscore';
import { A7PageSizeMatcher } from '@ark7/layout';
import { AppConfigurationService } from '@ark7/resources-common';
import { Component } from '@angular/core';
import { LocalStorage } from 'ngx-webstorage';

@Component({
    selector: 'home-promo-banner',
    templateUrl: './home-promo-banner.component.html',
    styleUrls: ['./home-promo-banner.component.scss'],
    standalone: false
})
export class HomePromoBannerComponent {
  @A7PageSizeMatcher('SM-') sm;
  @A7PageSizeMatcher('MD-') md;

  @LocalStorage()
  hidePromoBanner: boolean;

  constructor(private configurationService: AppConfigurationService) {}

  closePromoBanner() {
    this.hidePromoBanner = true;
  }

  get showPromoBanner() {
    return !this.hidePromoBanner && !this.sm && this.showPromoMessage;
  }

  get promoBannerMessage() {
    return this.configurationService.getConfig(
      'web.landing.promoBannerMessage',
    );
  }

  get showPromoMessage() {
    return !_.isEmpty(
      this.configurationService.getConfig('web.landing.promoBannerMessage'),
    );
  }
}
